var map = {
	"./": 135,
	"./blackHand.png": 716,
	"./blackRabbit.png": 717,
	"./bunny.png": 709,
	"./bunnys.png": 2089,
	"./calmos.png": 715,
	"./calmos1.png": 2090,
	"./clp": 116,
	"./clp/": 116,
	"./clp/corrosive.png": 721,
	"./clp/environment.png": 726,
	"./clp/flammable.png": 725,
	"./clp/index": 116,
	"./clp/index.js": 116,
	"./clp/inhalationSensitizer.png": 723,
	"./clp/irritant.png": 722,
	"./clp/oxidising.png": 724,
	"./flags/Belgium.png": 2091,
	"./flags/France.png": 564,
	"./flags/United-States.png": 565,
	"./flammable.png": 2092,
	"./fsc.png": 712,
	"./greendot.png": 710,
	"./hairColorAttention.jpg": 713,
	"./index": 135,
	"./index.js": 135,
	"./labelSymbols/manufacturer.JPG": 2093,
	"./leaflet.png": 708,
	"./leapingBunny.png": 714,
	"./manufacturer.JPG": 2094,
	"./recycling.png": 711,
	"./redHeart.png": 718,
	"./tmOrR.png": 719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2088;